module.exports = __webpack_public_path__ + "img/image_landscape.3af284c7.png";